class FindProductForm extends HTMLElement {
	connectedCallback() {
		this.querySelectorAll('[data-fp-tab-btn]').forEach((btn) =>
			btn.addEventListener('click', () => this._switchTab(btn)),
		);

		const waBtn = this.querySelector('[data-fp-wa-btn]');
		if (waBtn) waBtn.addEventListener('click', () => this._sendWhatsApp(waBtn));

		if (new URLSearchParams(window.location.search).get('contact_posted')) {
			requestAnimationFrame(() => {
				this.closest('section.find-product')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		}
	}

	_switchTab(activeBtn) {
		const target = activeBtn.dataset.fpTabBtn;
		const panelsEl = this.querySelector('[data-fp-panels]');
		const currentPanel = this.querySelector('[data-fp-panel].is-active');
		const nextPanel = this.querySelector(`[data-fp-panel="${target}"]`);

		if (!panelsEl || currentPanel === nextPanel) return;

		this.querySelectorAll('[data-fp-tab-btn]').forEach((btn) => {
			btn.classList.toggle('is-active', btn === activeBtn);
			btn.setAttribute('aria-selected', btn === activeBtn ? 'true' : 'false');
		});

		// Measure target panel height while still hidden
		const panelWidth = panelsEl.offsetWidth;
		nextPanel.style.cssText = `display:block;position:absolute;visibility:hidden;width:${panelWidth}px`;
		const toHeight = nextPanel.scrollHeight;
		nextPanel.style.cssText = '';

		// Lock current height, disable transition for the snap
		panelsEl.style.transition = 'none';
		panelsEl.style.height = panelsEl.offsetHeight + 'px';

		// Switch panels
		currentPanel.classList.remove('is-active');
		nextPanel.classList.add('is-active');

		// Animate to new height in next two frames (ensures repaint between snap and animate)
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				panelsEl.style.transition = '';
				panelsEl.style.height = toHeight + 'px';
			});
		});

		// Remove explicit height once animation finishes → back to auto
		panelsEl.addEventListener('transitionend', () => {
			panelsEl.style.height = '';
		}, { once: true });
	}

	_sendWhatsApp(btn) {
		const phone = btn.dataset.fpWaPhone;
		const product = (this.querySelector('[data-fp-wa-product]')?.value || '').trim();

		if (!product) {
			this.querySelector('[data-fp-wa-product]')?.focus();
			return;
		}

		window.open(`https://wa.me/${phone}?text=${encodeURIComponent(product)}`, '_blank');
	}
}

if (!customElements.get('find-product-form')) {
	customElements.define('find-product-form', FindProductForm);
}
